import React from "react";
import { Link } from "react-router-dom";

function Footer() {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="bg-gradient-to-b from-gray-700 via-black to-gray-900 text-gray-200">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 pt-16 pb-12">
        {/* Основной контент */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-10 md:gap-12 mb-16">
          {/* Услуги */}
          <div>
            <h3 className="text-lg font-semibold text-white mb-6 tracking-wide">
              Услуги
            </h3>
            <div className="space-y-4">
              <Link
                to="/payInfo"
                onClick={scrollToTop}
                className="block text-gray-100 hover:text-[#A1C349] font-medium transition-colors duration-300 text-base"
              >
                Төлөм
              </Link>
              <Link
                to="/deliveryInfo"
                onClick={scrollToTop}
                className="block text-gray-100 hover:text-[#A1C349] font-medium transition-colors duration-300 text-base"
              >
                Жеткирүү жана чогултуу
              </Link>
            </div>
          </div>

          {/* О компании */}
          <div>
            <h3 className="text-lg font-semibold text-white mb-6 tracking-wide">
              Компания
            </h3>
            <div className="space-y-4">
              <Link
                to="/about"
                onClick={scrollToTop}
                className="block text-gray-100 hover:text-[#A1C349] font-medium transition-colors duration-300 text-base"
              >
                AJAR MEBEL тууралуу
              </Link>
              <Link
                to="/privacy"
                onClick={scrollToTop}
                className="block text-gray-100 hover:text-[#A1C349] font-medium transition-colors duration-300 text-base"
              >
                Жеке маалыматты коргоо саясаты
              </Link>
            </div>
          </div>

          {/* Контакты */}
          <div>
            <h3 className="text-lg font-semibold text-white mb-6 tracking-wide">
              Байланыш
            </h3>
            <div className="space-y-4">
              <a
                href="tel:+996707178620"
                className="block text-gray-100 hover:text-[#A1C349] font-medium transition-colors duration-300 text-base"
              >
                +996 707 178 620
              </a>
              <p className="text-gray-100 font-medium text-base">
                10:00 – 19:00 (Бишкек убактысы)
              </p>
            </div>
          </div>

          {/* Соцсети */}
          <div>
            <h3 className="text-lg font-semibold text-white mb-6 tracking-wide">
              Соцтармактар
            </h3>
            <div className="flex flex-wrap gap-6">
              <a
                href="https://www.instagram.com/ajarmebel.kg/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-3xl text-gray-100 hover:text-[#A1C349] transition-all duration-300 hover:scale-110 transform"
                aria-label="Instagram"
              >
                <ion-icon name="logo-instagram"></ion-icon>
              </a>

              <a
                href="https://www.youtube.com/channel/UCtCtChpP2qT1pW0qgBkQvJA"
                target="_blank"
                rel="noopener noreferrer"
                className="text-3xl text-gray-100 hover:text-[#A1C349] transition-all duration-300 hover:scale-110 transform"
                aria-label="YouTube"
              >
                <ion-icon name="logo-youtube"></ion-icon>
              </a>

              <a
                href="https://www.facebook.com/profile.php?id=61568380180272"
                className="text-3xl text-gray-100 hover:text-[#A1C349] transition-all duration-300 hover:scale-110 transform"
                target="_blank"
                rel="noopener noreferrer"
              >
                <ion-icon name="logo-facebook"></ion-icon>
              </a>

              <a
                href="https://t.me/+-6ooyVjediE2YWYy"
                target="_blank"
                rel="noopener noreferrer"
                className="text-3xl text-gray-100 hover:text-[#A1C349] transition-all duration-300 hover:scale-110 transform"
                aria-label="Telegram"
              >
                <ion-icon name="paper-plane-outline"></ion-icon>
              </a>

              <a
                href="tel:+996707178620"
                className="text-3xl text-gray-100 hover:text-[#A1C349] transition-all duration-300 hover:scale-110 transform"
                aria-label="WhatsApp"
              >
                <ion-icon name="logo-whatsapp"></ion-icon>
              </a>
            </div>
          </div>
        </div>

        {/* Разделитель */}
        <div className="h-px bg-gray-400/50 my-10"></div>

        {/* Нижняя часть */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm">
          <div className="text-center md:text-left text-gray-100">
            <p>© {new Date().getFullYear()} AJAR MEBEL LTD</p>
            <p className="mt-2">
              Сайтты иштеп чыккан команда:{" "}
            </p>
           <a
                href="https://www.instagram.com/ascending_sales_online/"
                className="text-zinc-200 ml-1 spin-animation text-xl"
                target="_blank"
                rel="noopener noreferrer"
              >
                <ion-icon name="arrow-forward-outline"></ion-icon>
                <ion-icon name="logo-instagram"></ion-icon>
                <ion-icon name="arrow-back-outline"></ion-icon>
              </a>
          </div>

          <div className="text-center text-gray-100 font-medium">
            Соцтармактарыбызга жазылыңыз — жаңылыктарды калтырбаңыз!
          </div>

          <div className="text-center md:text-right text-gray-100 italic">
            Кыргызстанда жасалган • Жогорку сапат • Келечекке багытталган
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
